// Ideally this is kept somewhere in database so we can do CRUD operations and centralise it for reuse.
export const simproJobZones: Record<
	string,
	{
		numeric: number;
		alphabetical: string;
		text: string;
	}[]
> = {
	'New Zealand': [
		{ numeric: isStaging() ? 1 : 7, alphabetical: 'Bay of Plenty', text: 'Bay of Plenty' },
		{ numeric: isStaging() ? 2 : 5, alphabetical: 'Canterbury', text: 'Canterbury' },
		{ numeric: isStaging() ? 3 : 4, alphabetical: 'Central Districts', text: 'Central Districts' },
		{ numeric: isStaging() ? 5 : 2, alphabetical: 'Northland', text: 'Northland' },
		{
			numeric: isStaging() ? 6 : 3,
			alphabetical: 'Southland and Otago',
			text: 'Southland and Otago',
		},
		{ numeric: isStaging() ? 7 : 6, alphabetical: 'Taranaki', text: 'Taranaki' },
		{ numeric: isStaging() ? 8 : 1, alphabetical: 'Waikato', text: 'Waikato' },
	],
	Ireland: [
		{ numeric: isStaging() ? 4 : 39, alphabetical: 'Ireland', text: 'Ireland' }, // One zone for Ireland at the moment.
	],
	Australia: [
		{ numeric: isStaging() ? 10 : 41, alphabetical: 'Tasmania', text: 'Tasmania' }, // One zone for Australia at the moment.
	],
};

function isStaging() {
	return window.location.host.indexOf('staging') > -1;
}
